import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE } from 'ducks/slice';

import { overlay_default } from './defaults';
import { Overlay, OverlayClear, OverlayUpdate } from './types';
import { clearOverlayState, updateOverlayState } from './utils';

const initialState: Overlay = overlay_default;

export const overlaysSlice = createSlice({
  name: SLICE.OVERLAYS,
  initialState,
  reducers: {
    setOverlay: {
      reducer: (state: Overlay, action: PayloadAction<OverlayUpdate>) => {
        return updateOverlayState(state, action.payload.key, action.payload.data);
      },
      prepare: <K extends keyof Overlay>(payload: OverlayUpdate<K>) => ({ payload }),
    },
    updateOverlay: {
      reducer: (state: Overlay, action: PayloadAction<OverlayUpdate>) => {
        return updateOverlayState(state, action.payload.key, action.payload.data);
      },
      prepare: <K extends keyof Overlay>(payload: OverlayUpdate<K>) => ({ payload }),
    },
    clearOverlay: {
      reducer: (state: Overlay, action: PayloadAction<OverlayClear>) => {
        return clearOverlayState(state, action.payload);
      },
      prepare: (payload: OverlayClear) => ({ payload }),
    },
    resetOverlay: {
      reducer: (_: Overlay, action: PayloadAction<OverlayUpdate>) => {
        return updateOverlayState(overlay_default, action.payload.key, action.payload.data);
      },
      prepare: <K extends keyof Overlay>(payload: OverlayUpdate<K>) => ({ payload }),
    },
    clearOverlays: () => {
      return initialState;
    },
  },
});

export const { setOverlay, updateOverlay, clearOverlay, resetOverlay, clearOverlays } =
  overlaysSlice.actions;

export default overlaysSlice.reducer;
